import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-saldo-alocado',
  templateUrl: './saldo-alocado.component.html',
  styleUrls: ['./saldo-alocado.component.css']
})
export class SaldoAlocadoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
